import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../../core/store/reducers";
import { loadReport } from "../thunks/loadReportData";
import { BusinessActivitiesReportData } from "../types";

export const useBusinessActivitiesReportData = () => {
  const data = useSelector<
    StoreType,
    BusinessActivitiesReportData[] | undefined
  >((s) => s.data.reports.exchbusiness.businessActivities.data);

  const dispatch = useDispatch();
  const dispatchLoadData = React.useCallback(() => dispatch(loadReport()), [
    dispatch,
  ]);

  return [data, dispatchLoadData] as [typeof data, typeof dispatchLoadData];
};
